import React from 'react';
import { Reveal } from './Reveal';
import { kitContents } from '../data/kitContents';
export function KitContentsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-106" data-mp="209o2oa1qn9ku">
      <Reveal className="mx-auto max-w-5xl" data-id="element-107" data-mp="257pm4w32tawu">
        <div className="mb-12 text-center" data-id="element-108" data-mp="256xozgttz54g">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-109" data-mp="2a725v7yni1v7">WHAT&apos;S INSIDE</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-110" data-mp="2f6yan9f69xbt">📐 What&apos;s Inside the Math Ready Pack?</h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-111" data-mp="2j6gzgga46sjx">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="rounded-2xl border border-brand-dark bg-brand-main p-7 text-center" data-id="element-112" data-mp="2sxjyzdneazh3">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-purple" strokeWidth={1.5} aria-hidden="true" data-id="element-113" data-mp="2xxg117cj8gu0" />
              <h3 className="mt-5 text-xl font-bold text-brand-blue" data-id="element-114" data-mp="32v7rdwxj3uw3">{title}</h3>
              <p className="mt-2 text-sm text-brand-gray" data-id="element-115" data-mp="10m5fto5kxxi8">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}